import * as React from 'react';
import { LProps, withLocalization } from '../../utils/wrappers';
import { compose } from 'redux';
import ExternalLink from '../../shared/ExternalLink';

const CompetitionAboutTextSF = ({ t }: LProps<{}>) => (
  <p>
    <span>
      {t('The CCSF Sustainability Challenge is a competition between SF Environment, Public Works, Planning, SFO, and Rec and Park Department Division Teams. For questions or comments, please contact')}
      &nbsp;
    </span>
    <ExternalLink href={'mailto:Sierra.Barsten@sfgov.org'}>Sierra.Barsten@sfgov.org</ExternalLink>
    <span> {t('or')} </span>
    <ExternalLink href={'mailto:Brian.Reyes@sfgov.org'}>Brian.Reyes@sfgov.org</ExternalLink>.
  </p>
);

export default compose(
   withLocalization('competitionAboutText')
)(CompetitionAboutTextSF) as React.SFC;
